module.exports = __webpack_public_path__ + "img/图片7.09d9208d.png";